import { ComponentProps, ReactNode } from 'react';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '../theme/tokens';
import { FlexGap } from './FlexGap';
import { IconWrapper } from './Icon';
import { Heading3, Paragraph } from './Text';

const Container = styled(FlexGap)`
	align-items: center;
	flex-direction: column;
	text-align: center;
	max-width: 210px;
	width: 100%;
`;

const Card = styled(Flex)`
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	padding: ${tokens.padding.container}px;
	background: ${tokens.surface.white};
	border: 1px solid ${tokens.border.subtle};
	border-radius: ${tokens.radius.md}px;
	box-shadow: ${tokens.shadow.xs};

	${Container} {
		max-width: none;
	}
`;

const Copy = styled(FlexGap)`
	align-items: center;
	flex-direction: column;
	width: 100%;
`;

type Props = {
	icon?: ReactNode;
	title?: string;
	description?: string;
	small?: boolean;
	footer?: ReactNode;
};

export function Empty(props: Props) {
	const hasCopy = Boolean(props.title || props.description);

	return (
		<Container gap={tokens.gap.list}>
			{props.icon && (
				<IconWrapper size={props.small ? 20 : 24} color={tokens.icon.tertiary}>
					{props.icon}
				</IconWrapper>
			)}
			{hasCopy && (
				<Copy gap={tokens.gap.inline}>
					{props.title && <Heading3 textAlign="center">{props.title}</Heading3>}
					{props.description && <Paragraph textAlign="center">{props.description}</Paragraph>}
				</Copy>
			)}
			{props.footer}
		</Container>
	);
}

function EmptyCard(props: ComponentProps<typeof Empty>) {
	return (
		<Card>
			<Empty {...props} />
		</Card>
	);
}

Empty.Card = EmptyCard;
